import AjaxBuilder from "../../../Common/AjaxBuilder";
import SearchStepTypes from "../../../Common/SearchStepTypes";
import { Util } from "../../../Common/Util";
import { SearchPopupTimer } from "../../CommonComponents/Search/SearchPopupTimer";
import { Datepicker } from "./Components/Datepicker";
import { FilterDate } from "./Components/FilterDate";
import { Filters } from "./Components/Filters";
import { Intercity } from "./Components/Intercity";
import { ItemsWrapper } from "./Components/ItemsWrapper";
import { Loader } from "./Components/Loader";
import { NoRoutes } from "./Components/NoRoutes";
import { Progress } from "./Components/Progress";
import { SearchTickets } from "./Components/SearchTickets";
import { Sort } from "./Components/Sort";
import { StationFrom } from "./Components/StationFrom";
import { StationTo } from "./Components/StationTo";
import { Swap } from "./Components/Swap";
import { TrainReturnTicketSelector } from "./Components/TrainReturnTicketSelector";

export class RailwaySearchModule {
    constructor({ page, handler, success, error, route, search }) {
        this.$page = page;
        this.$searchModule = $('#widget_form');

        this._route = route; //Может быть поиском маршрутов на странице или поиском с редиректом на страницу поиска
        this._lang = $('html').attr('lang');

        this._searchTickets = handler.bind(this);
        this._searchTicketsSuccess = success.bind(this);
        this._searchTicketsError = error.bind(this);

        this._routes = [];
        this._searchTrigger = search;

        this._step = this.$page.find('input[name="step"]').val();

        this._firstLoad = false; // При первой загрузке страницы, нужна только для живого поиска новых билетов и сброса сессии

        this._getRoutes = this._getRoutes.bind(this);
        this.updateRoutes = this.updateRoutes.bind(this);

        this._init();
    }

    async _init() { 
        this._loader = new Loader();

        this._stationFrom = new StationFrom({
            searchModule: this.$searchModule,
            loader: this._loader,
            lang: this._lang,
            changeDatepickerHandler: this._changeDatepicker.bind(this),
        });

        this._stationTo = new StationTo({
            searchModule: this.$searchModule,
            loader: this._loader,
            lang: this._lang,
            changeDatepickerHandler: this._changeDatepicker.bind(this),
        });

        this._swap = new Swap({
            searchModule: this.$searchModule,
            stationFrom: this._stationFrom,
            stationTo: this._stationTo,
        });

        this._datepicker = new Datepicker({
            searchModule: this.$searchModule,
            lang: this._lang,
        });

        this._searchPopupTimer = new SearchPopupTimer({
            page: this.$page,
            handler: this._searchTickets,
        });

        this._searchTicketsBtn = new SearchTickets({
            searchModule: this.$searchModule,
            handler: this._searchTickets,
        });

        this._itemsWrapper = new ItemsWrapper({
            page: this.$page,
            handler: this._saveSelectedTrain.bind(this),
        });

        this._trainReturnTicketSelector = new TrainReturnTicketSelector({
            page: this.$page,
            datepicker: this._datepicker,
        });

        this._filterDate = new FilterDate({
            page: this.$page,
            datepicker: this._datepicker,
            handler: this._searchTickets,
        });

        this._noRoutes = new NoRoutes({
            page: this.$page,
            lang: this._lang,
        });

        this._progress = new Progress({
            page: this.$page,
            lang: this._lang,
        });

        this._intercity = new Intercity({
            page: this.$page,
            getRoutes: this._getRoutes,
        });

        this._sort = new Sort({
            page: this.$page,
            itemsWrapper: this._itemsWrapper,
            updateRoutes: this.updateRoutes,
            getRoutes: this._getRoutes,
        });

        this._filters = new Filters({
            page: this.$page,
            lang: this._lang,
            updateRoutes: this.updateRoutes,
            getRoutes: this._getRoutes,
        });
        
        if (this._searchTrigger) {
            await this._stationFrom.getCities();
            await this._stationTo.getCities();

            this._searchTickets();
        } else {
            await this._stationFrom.getCities();
            await this._stationTo.getCities();
        }
    }

    _updateRoute(stateFrom, stateTo, startDate, endDate = null) {
        let route = `${Util.getLocalization()}train/search/`;

        const date = endDate ? `${startDate}_${endDate}` : startDate;
        this._step = this._firstLoad ? SearchStepTypes.DEPARTURE_STEP : this._step;

        route = `${route}${this._step}/${stateFrom.val.replace(' ', '-')}/${stateTo.val.replace(' ', '-')}/${stateFrom.id}/${stateTo.id}/${date}/`;

        window.history.pushState({}, null, route);
    }

    _saveSelectedTrain(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedItem = event.target;

        const trainCarClass = $(selectedItem).data('train_car');
        const trainNumber = $(selectedItem).closest('.railway_results_item').data('routeid');

        if (!trainNumber || !trainCarClass) return;

        const train = this._getRoutes().find(route => route['number'] === trainNumber);

        new AjaxBuilder({
            route: `${Util.getLocalization()}train/save-train/`,
            data: {
                sessionId: train.session_id,
                trainNumber: train.number,
                classNumber: trainCarClass,
                apiName: 'Ukrzaliznytsia',
                step: this._step,
            },
            token: Util.token(),
        }, 'POST').execute({
            success: this._saveSelectedTrainSuccess.bind(this),
            error: this._saveSelectedTrainError.bind(this),
        });
    }

    _saveSelectedTrainSuccess(data) {
        const stateFrom = this._stationFrom.getSelectedCity();
        const stateTo = this._stationTo.getSelectedCity();
        const startDate = this._datepicker.getStartDate();
        const endDate = this._datepicker.getEndDate();
        const date = endDate ? `${startDate}_${endDate}` : startDate;

        const route = `${Util.getLocalization()}train/seats/${this._step}/${stateFrom.val.replace(' ', '-')}/${stateTo.val.replace(' ', '-')}/${stateFrom.id}/${stateTo.id}/${date}/`;
        window.location = route;
    }

    _saveSelectedTrainError(data) {
        console.log(data);
    }

    //Открыть страницу с поездом и вагонами
    _openSeatSelection(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedItem = event.target;

        const trainCarClass = $(selectedItem).data('train_car');
        const trainNumber = $(selectedItem).closest('.railway_results_item').data('routeid');

        if (!trainNumber || !trainCarClass) return;

        const train = this._getRoutes().find(route => route['number'] === trainNumber); 

        const stateFrom = this._stationFrom.getSelectedCity();
        const stateTo = this._stationTo.getSelectedCity();
        const startDate = this._datepicker.getStartDate();
        const endDate = this._datepicker.getEndDate();

        const date = endDate ? `${startDate}_${endDate}` : startDate;

        const route = `${Util.getLocalization()}train/seats/${this._step}/${stateFrom.val.replace(' ', '-')}/${stateTo.val.replace(' ', '-')}/${stateFrom.id}/${stateTo.id}/${date}/${train.session_id}/${train.number}/${trainCarClass}/`;
        window.location = route;
    }

    _getRoutes() {
        return this._routes;
    }

    updateRoutes(routes) {
        this._routes = routes;
        return this;
    }

    _scrollToTop() {
        $('html, body').animate({ scrollTop: 0 }, 500);
    }

    _changeDatepicker() {
        const stateFrom = this._stationFrom.getSelectedCity();
        const stateTo = this._stationTo.getSelectedCity();

        if (!stateFrom || !stateTo ) return;

        this._datepicker.getCalendarPrices(stateFrom.id, stateTo.id);
    }
}